module.exports = __webpack_public_path__ + "img/darpa-simple.ab68160a.png";